import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IPersonalSalud } from 'modelos/src';
import { retry, Subscription, throwError, timer } from 'rxjs';
import { AuxiliaresModule } from '../../../../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { PIEZAS_DETALLE } from '../../../../../../componentes/detalle/detalle.components';
import { iconoRolSalud } from '../../presentacion-entidades';
import { CrearEditarPersonalSaludComponent } from '../crear-editar-personal-salud/crear-editar-personal-salud.component';
import { FormularioDialogService } from '../../../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-detalles-personal-salud',
  imports: [AuxiliaresModule, ...PIEZAS_DETALLE],
  templateUrl: './detalles-personales-salud.component.html',
  styleUrls: [
    '../../../../../../componentes/detalle/detalle-pagina.scss',
    '../../detalle-emergencias.scss',
  ],
})
export class DetallesPersonalSaludComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private formularios = inject(FormularioDialogService);
  private lista2 = inject(Lista2Service);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  helper = inject(HelperService);

  public loading = true;
  public id = '';
  public personal?: IPersonalSalud;
  private personal$?: Subscription;
  private params$?: Subscription;

  public icono = 'medical_services';
  /**
   * El cliente, sin HTML. Se calcula al dibujar: el índice de clientes de la
   * jerarquía puede llegar después que la entidad (al recargar la página el
   * chip quedaba vacío).
   */
  get cliente(): string | undefined {
    if (HelperService.getTipoCliente() === 'Final') return undefined;
    const e = this.personal;
    const cadena = this.clienteJerarquia.cadena(e?.cliente ?? e?.idCliente);
    return cadena[cadena.length - 1]?.nombre || e?.cliente?.nombre || undefined;
  }
  public fechaAlta?: string;

  public puedeEditar = this.helper.tienePermiso(
    'Emergencias Médicas - Editar personal de salud',
  );

  private listar(): void {
    this.personal$?.unsubscribe();
    this.personal$ = this.lista2
      .personalSalud(this.id, 30)
      // Un request que falla terminaba el refresco de cada 30 s para siempre.
      // Si todavía no se cargó nunca, el error sigue de largo.
      .pipe(
        retry({
          delay: (error) =>
            this.personal ? timer(30000) : throwError(() => error),
        }),
      )
      .subscribe({
        next: (data) => {
          if (!HelperService.cambiaronLosDatos(this.personal, data)) return;
          this.personal = data;
          this.armar();
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.helper.notifError(error);
          // No existe o no hay acceso: sin esto quedaba el spinner para siempre
          this.loading = false;
        },
      });
  }

  private armar(): void {
    const p = this.personal;
    if (!p) return;
    this.icono = iconoRolSalud(p.rol);
    this.fechaAlta = p.fechaCreacion
      ? HelperService.getFechaYHora(p.fechaCreacion)
      : undefined;
  }

  /** Edita en diálogo; al guardar se recarga el detalle. */
  public editar(): void {
    const ref = this.formularios.abrir(CrearEditarPersonalSaludComponent, {
      tamano: 'mediano',
      data: { id: this.id },
    });
    ref.afterClosed().subscribe((guardado) => {
      if (guardado) this.listar();
    });
  }

  ngOnInit(): void {
    // Al cambiar el id de la ruta Angular reutiliza el componente
    this.params$ = this.route.paramMap.subscribe((params) => {
      this.id = params.get('id') ?? '';
      this.loading = true;
      this.personal = undefined;
      this.listar();
    });
  }

  ngOnDestroy(): void {
    this.personal$?.unsubscribe();
    this.params$?.unsubscribe();
  }
}
